// biome-ignore lint/style/noRestrictedImports: This is meant to be imported here
import djs from 'dayjs'
import 'dayjs/locale/es.js'
import 'dayjs/locale/pt-br.js'
import customParseFormat from 'dayjs/plugin/customParseFormat.js'
import durationPlugin from 'dayjs/plugin/duration.js'
import isBetween from 'dayjs/plugin/isBetween.js'
import isoWeek from 'dayjs/plugin/isoWeek.js'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter.js'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore.js'
import isToday from 'dayjs/plugin/isToday.js'
import relativeTime from 'dayjs/plugin/relativeTime.js'
import timezone from 'dayjs/plugin/timezone.js'
import updateLocale from 'dayjs/plugin/updateLocale.js'
import utc from 'dayjs/plugin/utc.js'

djs.extend(relativeTime)
djs.extend(updateLocale)
djs.extend(durationPlugin)
djs.extend(isoWeek)
djs.extend(timezone)
djs.extend(utc)
djs.extend(isToday)
djs.extend(isSameOrAfter)
djs.extend(isSameOrBefore)
djs.extend(isBetween)
djs.extend(customParseFormat)

djs.updateLocale('en', {
	relativeTime: {
		future: 'in %s',
		past: '%s ago',
		s: '<1 min',
		m: '1 min',
		mm: '%d min',
		h: '1 hr',
		hh: '%d hr',
		d: '1 D',
		dd: '%d D',
		M: '1 M',
		MM: '%d M',
		y: '1 Y',
		yy: '%d Y',
	},
})

declare module 'dayjs' {
	interface Dayjs {
		next(count: number, unit: 'minute' | 'hour' | 'day'): Dayjs
		ceil(count: number, unit: 'minute' | 'hour' | 'day'): Dayjs
		percentBetween(start: Dayjs, end: Dayjs): number
		clamp(min: Dayjs, max: Dayjs): Dayjs
	}
}
djs.extend(() => {
	djs.prototype.next = function (time: number, unit: 'minute' | 'hour' | 'day') {
		return this.add(time - (this.get(unit) % time), unit).startOf(unit)
	}
	djs.prototype.ceil = function (time: number, unit: 'minute' | 'hour' | 'day') {
		if (this.get(unit) % time === 0 && this.isSame(this.startOf(unit))) {
			return this
		}
		return this.next(time, unit)
	}
	djs.prototype.percentBetween = function (start: Dayjs, end: Dayjs) {
		return (this.valueOf() - start.valueOf()) / end.diff(start)
	}
	djs.prototype.clamp = function (min: Dayjs, max: Dayjs) {
		if (this.isBefore(min)) return dayjs(min)
		if (this.isAfter(max)) return dayjs(max)
		return this
	}
})

export const dayjs = djs
export const duration = djs.duration
export type Dayjs = djs.Dayjs
export type ConfigType = djs.ConfigType
